import { useMemo } from 'react';
import { usePhanBoThuTienTable } from './usePhanBoThuTienTable';
import { formatDate, roundNumber } from '@/lib/formatUtils';
import { getInputTableColumns } from '../cols-definition';

const formatAmount = (value?: string | number) =>
  Number(value || 0).toLocaleString('vi-VN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const usePhanBoThuTienPage = () => {
  const tableState = usePhanBoThuTienTable();
  const allocationColumns = useMemo(
    () => getInputTableColumns(tableState.detailTable.toggleSelection, tableState.detailTable.onDocumentClick),
    [tableState.detailTable.onDocumentClick, tableState.detailTable.toggleSelection]
  );
  const receipt = tableState.selection.selectedReceipt;
  const allocatedAmount = useMemo(
    () => roundNumber(tableState.detailTable.rows.reduce((total, row) => total + Number(row.da_pb_ct_nt || 0), 0)),
    [tableState.detailTable.rows]
  );
  const remainingAmount = useMemo(
    () => roundNumber(tableState.detailTable.rows.reduce((total, row) => total + Number(row.cl_nt || 0), 0)),
    [tableState.detailTable.rows]
  );

  return {
    searchDialog: tableState.searchDialog,
    documentEntry: tableState.documentEntry,
    table: tableState.table,
    selection: tableState.selection,
    detailTable: tableState.detailTable,
    allocationTable: {
      rows: tableState.detailTable.rows,
      columns: allocationColumns,
      isLoading: tableState.detailTable.isLoading,
      summary: receipt
        ? `Phiếu thu số ${receipt.so_ct || receipt.voucher || '-'} ngày ${formatDate(
            receipt.ngay_ct || receipt.receiptDate
          )} phân bổ: ${formatAmount(allocatedAmount)}, còn lại: ${formatAmount(remainingAmount)}`
        : 'Chọn một phiếu thu để xem chi tiết hóa đơn',
      refresh: tableState.detailTable.refresh
    },
    actions: {
      handleSearch: tableState.searchDialog.onOpen
    }
  };
};
